import { http } from '../../../../api/http';
import type {
  TareoResumen, TareoDiario, TurnoTrabajadorResumen,
  AsignarTurnoRequest, GenerarTareoResponse,
} from '../types/tareo';

const TAREO = '/planilla/tareo';
const TURNO_TRAB = '/planilla/turno-trabajador';

export class TareoService {
  // ── Tareo Diario ──
  static async getResumen(idPeriodo: number): Promise<TareoResumen[]> {
    const response = await http.get(`${TAREO}/resumen/${idPeriodo}`);
    return response.data;
  }

  static async getByPeriodo(idPeriodo: number): Promise<TareoDiario[]> {
    const response = await http.get(`${TAREO}/periodo/${idPeriodo}`);
    return response.data;
  }

  static async getByTrabajadorPeriodo(idTrabajador: number, idPeriodo: number): Promise<TareoDiario[]> {
    const response = await http.get(`${TAREO}/trabajador/${idTrabajador}/periodo/${idPeriodo}`);
    return response.data;
  }

  static async saveTareo(tareo: TareoDiario): Promise<TareoDiario> {
    const response = await http.post(TAREO, tareo);
    return response.data;
  }

  static async deleteTareo(id: number): Promise<void> {
    await http.delete(`${TAREO}/${id}`);
  }

  // ── Turno x Trabajador ──
  static async getTurnosTrabajador(): Promise<TurnoTrabajadorResumen[]> {
    const response = await http.get(TURNO_TRAB);
    return response.data;
  }

  static async getTurnosByTrabajador(idTrabajador: number): Promise<TurnoTrabajadorResumen[]> {
    const response = await http.get(`${TURNO_TRAB}/trabajador/${idTrabajador}`);
    return response.data;
  }

  static async asignarTurnoMasivo(request: AsignarTurnoRequest): Promise<{ count: number; message: string }> {
    const response = await http.post(`${TURNO_TRAB}/asignar`, request);
    return response.data;
  }

  static async updateTurnoTrabajador(id: number, data: Partial<TurnoTrabajadorResumen>): Promise<TurnoTrabajadorResumen> {
    const response = await http.put(`${TURNO_TRAB}/${id}`, data);
    return response.data;
  }

  static async deleteTurnoTrabajador(id: number): Promise<void> {
    await http.delete(`${TURNO_TRAB}/${id}`);
  }

  static async generarTareo(idPeriodo: number): Promise<GenerarTareoResponse> {
    const response = await http.post(`${TURNO_TRAB}/generar-tareo`, { idPeriodo });
    return response.data;
  }
}
